import {NgModule} from '@angular/core';
import {ControlsModule} from '../controls/controls.module';
import {NavigatorComponent} from './navigator/navigator.component';
import {AccordionComponent} from './accordion/accordion.component';
import {AccordionTabComponent} from './accordion/accordion-tab.component';
import {CaseIdComponent} from './case-id/case-id.component';
import {CalendarComponent} from './calendar/calendar.component';
import {SearchTreeComponent} from './search-tree/search-tree.component';
import {PipesModule} from '../pipes/pipes.module';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {VinComponent} from './vin/vin.component';
import { SearchTreeLiteComponent } from './search-tree-lite/search-tree-lite.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import {TabComponent} from './tab/tab.component';
import {NgSelectModule} from '@ng-select/ng-select';
import { VinLightComponent } from './vin-light/vin-light.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
    declarations: [
        NavigatorComponent,
        AccordionComponent,
        AccordionTabComponent,
        CaseIdComponent,
        VinComponent,
        SearchTreeComponent,
        CalendarComponent,
        SearchTreeLiteComponent,
        ErrorMessageComponent,
        TabComponent,
        VinLightComponent
    ],
    imports: [
        RouterModule,
        ControlsModule,
        PipesModule,
        NgSelectModule,
        MatTabsModule,
        MatMenuModule
    ],
    exports: [
        NavigatorComponent,
        AccordionComponent,
        AccordionTabComponent,
        CaseIdComponent,
        SearchTreeComponent,
        SearchTreeLiteComponent,
        CalendarComponent,
        VinComponent,
        ControlsModule,
        RouterModule,
        CommonModule,
        PipesModule,
        ErrorMessageComponent,
        VinLightComponent
    ]
})
export class ComponentsModule {
}
